import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bag",
  "use": "bag-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" id=\"bag\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h40v40H0z\" /><path d=\"M23.151 12.516A3.099 3.099 0 0020.118 10a3.099 3.099 0 00-3.026 2.5M13 28.72h14.244V14.938H13z\" stroke=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol